/** Reveal each mobile preview after it rests in the middle of the usable screen. */
export function observeScrollPreviews() {
  if (typeof IntersectionObserver === 'undefined' || !window.matchMedia) return () => {};
  const mobile = window.matchMedia('(max-width: 980px), (hover: none) and (pointer: coarse)');
  const timers = new Map();
  let observer;
  let margin;

  function reset(preview) {
    clearTimeout(timers.get(preview));
    timers.delete(preview);
    preview.classList.remove('is-scroll-photo');
  }

  function onIntersection(entries, source) {
    if (source !== observer) return;
    for (const { target: preview, isIntersecting } of entries) {
      if (!isIntersecting) {
        reset(preview);
      } else if (!timers.has(preview)) {
        const timer = setTimeout(async () => {
          const original = preview.querySelector('.project-preview-original');
          if (!original?.hasAttribute('href')) return;
          try {
            await original.decode?.();
          } catch {
            return; // Keep the paper in place if the underlying photo failed to load.
          }
          if (timers.get(preview) === timer) preview.classList.add('is-scroll-photo');
        }, 1100);
        timers.set(preview, timer);
      }
    }
  }

  function configure() {
    if (!mobile.matches || document.hidden) {
      observer?.disconnect();
      observer = undefined;
      for (const preview of timers.keys()) reset(preview);
      return;
    }
    // Use pixel margins: IntersectionObserver resolves percentages against viewport width.
    const header = window.innerWidth <= 980 ? document.querySelector('header').offsetHeight : 0;
    const inset = Math.round(Math.max(0, window.innerHeight - header) * .4);
    const nextMargin = `-${header + inset}px 0px -${inset}px 0px`;
    if (observer && margin === nextMargin) return;
    margin = nextMargin;
    observer?.disconnect();
    observer = new IntersectionObserver(onIntersection, { rootMargin: margin });
    document.querySelectorAll('.project-pin .project-preview').forEach(preview => observer.observe(preview));
  }

  mobile.addEventListener('change', configure);
  window.addEventListener('resize', configure, { passive: true });
  document.addEventListener('visibilitychange', configure);
  configure();
  return preview => observer?.observe(preview);
}
